module.exports = __webpack_public_path__ + "fonts/31E180_1_0.9fe41be.ttf";